import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import { ark, HTMLArkProps } from '@ark-ui/solid';

type TheadProps = HTMLArkProps<'thead'>;

export default function Thead(props: TheadProps): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  const [split, rest] = splitProps(merged, ['class', 'children']);
  return (
    <ark.thead
      class={twMerge(`bg-bg-disabled`, split.class)}
      {...rest}
    >
      {split.children}
    </ark.thead>
  );
}
